/*global _ */
import props from './../../../../props/inputs'

import InputMixin from '../../../../mixins/form/input'
import DesignerMixin from './designer'

const mixins = [InputMixin, DesignerMixin]

export const OPTIONS_PROP = 'advancedSettings'

export default {
  name: 're-number-input-buttons',
  mixins,
  props: {
    ...props,
    decreaseLabel: {
      type: String,
      default: '-' // prefer `−` (U+2212) instead of `-` (U+002D normal hyphen minus)
    },
    increaseLabel: {
      type: String,
      default: '+'
    },
    max: {
      type: [Number, String],
      default() {
        return null
      }
    },
    min: {
      type: [Number, String],
      default() {
        return 1
      }
    }
  },
  data() {
    return {
      optionsPropName: OPTIONS_PROP
    }
  },
  computed: {
    noMoreDecrease() {
      return this.model <= this.min
    },
    noMoreIncrease() {
      return this.max && this.model >= this.max
    },
  },
  methods: {
    getLabelExtraClasses() {
      return ['re-number-input-label', this.labelClass]
    },
    increase() {
      if (!this.noMoreIncrease) {
        this.model = this.model + 1
        this.$emit('increase', this.model)
      }
    },
    decrease() {
      if (!this.noMoreDecrease) {
        this.model = this.model - 1
        this.$emit('decreased', this.model)
      }
    }
  },
}
